export const SHOW_LOADER = "SHOW_LOADER";
export const HIDE_LOADER = "HIDE_LOADER";
export const EDIT_CASE = "EDIT_CASE";
export const CLEAN_EDIT_CASE = "CLEAN_EDIT_CASE";
export const SHOW_ADMIN_PANEL = "SHOW_ADMIN_PANEL";
export const HIDE_ADMIN_PANEL = "HIDE_ADMIN_PANEL";
export const SEARCH = "SEARCH";
